export default __webpack_public_path__ + "static/media/edit-user-icon.4dcc7b65.svg";